import { loadShareSync} from "@module-federation/runtime";
export const __synthetic = loadShareSync('@tanstack/react-query')();
